(function () {
        'use strict';

        angular
            .module('jotApp')
            .controller('TestScheduleFailedTestsController', TestScheduleFailedTestsController);

        TestScheduleFailedTestsController.$inject = ['$stateParams', '$state', 'pagingParams', 'paginationConstants', 'entity', 'testSchedule'];

        function TestScheduleFailedTestsController($stateParams, $state, pagingParams, paginationConstants, entity, testSchedule) {
            var vm = this;
            vm.testSchedule = testSchedule;
            vm.scheduleResults = entity;
            vm.tabObjectsToExport = [];
            vm.exportTable = exportTable;
            vm.loadAllToExport = loadAllToExport;
            function loadAllToExport() {
                var page = {
                    page: 0,
                    size: 2000,
                    sort: sort(),
                    /*search: vm.charToSearch*/
                };
                var dataExport = {
                    /*ch: vm.charToSearch,*/
                    filter: pagingParams.filter
                };

                function onSuccessExport(data, headers) {
                    vm.totalItemsExport = headers('X-Total-Count');
                    for (var i = 0; i < data.length; i++) {
                        vm.tabObjectsToExport.push(data[i]);
                    }
                    if (vm.tabObjectsToExport.length < vm.totalItemsExport) {
                        page.page = page.page + 1;
                        WarningsDashboard.search(page, vm.filter, onSuccessExport, onErrorExport);
                    } else {
                        vm.filter.warningGetAll = null;
                    }
                }

                function onErrorExport(error) {
                    AlertService.error(error.data.message);
                    reject();
                }

                if (vm.tabObjectsToExport.length < 1) {
                    vm.filter.warningGetAll = "all";
                    WarningsDashboard.search(page, vm.filter, onSuccessExport, onErrorExport);
                }
            }
            function exportTable(type) {
                if (type == 'pdf') {
                    $('#tableToExport').tableExport({
                        type: 'pdf',
                        pdfFontSize: '7',
                        escape: 'false',
                        ignoreColumn: [0,4],
                        size: {1: 100, 2: 400, 3: 120},
                        tableName: vm.testSchedule.name
                    });
                } else if (type != null) {
                    $('#tableToExport').tableExport({ignoreColumn: [0,4],type: type, escape: 'false', tableName: vm.testSchedule.name});
                }
            }
            vm.downloadPdf = function (detailed) {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.href = "api/result-pdf/pdf/" + vm.testSchedule.id + "/" + detailed;
                a.setAttribute("target", "_blank");
                a.download = name[name.length - 1];
                a.click();
            };
            vm.downloadCsv = function (detailed) {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.href = "api/result-csv/csv/" + vm.testSchedule.id + "/" + detailed;
                a.setAttribute("target", "_blank");
                a.download = name[name.length - 1];
                a.click();
            };
        }
    }
)
();
